/**
 * URL 주소에서 도메인명을 세련되게 추출해주는 유틸리티 함수
 */
export const getDomainName = (url: string): string => {
  if (!url) return '';
  try {
    // 프로토콜이 없는 경우 URL 생성자가 에러를 던지므로 http://를 임시로 붙여줌
    let targetUrl = url.trim();
    if (!/^https?:\/\//i.test(targetUrl)) {
      targetUrl = 'http://' + targetUrl;
    }
    const parsed = new URL(targetUrl);
    const hostname = parsed.hostname.toLowerCase();

    // 주요 도메인 매핑 테이블
    const domainMapping: Record<string, string> = {
      'github.com': 'GitHub',
      'wikipedia.org': 'Wikipedia',
      'ko.wikipedia.org': 'Wikipedia (KR)',
      'en.wikipedia.org': 'Wikipedia (EN)',
      'google.com': 'Google',
      'google.co.kr': 'Google KR',
      'youtube.com': 'YouTube',
      'youtu.be': 'YouTube',
      'naver.com': 'Naver',
      'daum.net': 'Daum',
      'tistory.com': 'Tistory',
      'facebook.com': 'Facebook',
      'twitter.com': 'Twitter',
      'x.com': 'X (Twitter)',
      'instagram.com': 'Instagram',
      'medium.com': 'Medium',
      'stackoverflow.com': 'Stack Overflow',
    };

    // exact match 또는 부분 매칭
    for (const key in domainMapping) {
      if (hostname === key || hostname.endsWith('.' + key)) {
        return domainMapping[key];
      }
    }

    // 매칭되지 않는 일반 도메인은 hostname에서 www.를 떼고 도메인 영역만 깔끔하게 출력
    let cleaned = hostname.replace(/^www\./i, '');
    if (cleaned.length > 25) {
      cleaned = cleaned.substring(0, 22) + '...';
    }
    return cleaned;
  } catch (error) {
    // URL 형식이 아예 아닐 경우 그대로 15글자 정도로 잘라서 반환
    const trimmed = url.trim();
    return trimmed.length > 20 ? trimmed.substring(0, 17) + '...' : trimmed;
  }
};
